// basic usage
const $loader = $('.site-loader');

$loader.stop().fadeOut(1000, function() {
    $loader.remove();
});
